import { defineComponent as _defineComponent } from 'vue'
import { ModalData } from '@/models/ModalData';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketsModal',
  emits: ['cancel', 'ok'],
  setup(__props, { expose, emit }) {


const data = ref<ModalData | null>(null)

const showModal = (modalData: ModalData) => {
  data.value = modalData
}

const hideModal = () => {
  data.value = null
}



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cancel = () => {
  emit('cancel', data.value)
  hideModal()
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ok = () => {
  emit('ok', data.value)
  hideModal()
}

expose({ showModal, hideModal });


const __returned__ = { data, showModal, hideModal, emit, cancel, ok, ModalData, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})